import React, { useEffect } from 'react';
import './style.css';
import Logo from '../../Images/Logo.png'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';


const LOGINURL = "api/user/login"

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);


  document.title = "Login - Jain Sadhana"
  localStorage.clear()




  // Handle login user
  async function HandleLOGIN(e) {
    setLoading(true)
    e.preventDefault();

    const data = { email, password }

    try {
      const response = await axios.post(LOGINURL, data);
      if (response?.status === 200) {
        localStorage.setItem("user_token", response?.data?.token)
        localStorage.setItem("user_id", response?.data?.user?._id)
        navigate("/menu/aartilist")
        toast.success('Login Successfully')
        setLoading(false)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
      setPassword("")
      setLoading(false)

    }
  };


  return (<>
    <section className="login-form-section bg-pink">
      <div className="container-fluid">
        <div className="row main ">


          <div className="col-md-6 col-lg-6 d-none d-sm-block login-left-main  d-flex flex-column ">


            <div className='d-flex flex-column login-left-section justify-content-center align-items-center ' >
              <img className='img-fluid logo' src={Logo} alt="Logo" />
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 login-right-main   bg-smyellow">
            <div className=' mx-5 bg-darkyellow login-right-section form-div'>
              <form className='mx-5 login-form' onSubmit={HandleLOGIN}>
                <h1 className='text-center ' >Jain Sadhana Login</h1>

                {/* email */}
                <div className="mb-2">
                  <label for="email" className="form-label  text-black ">Email address</label>
                  <input type="email" className="form-control input" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                {/* Password */}
                <div className="mb-2">
                  <label for="login-password" className="form-label  text-black ">Password</label>
                  <input type="password" className="form-control input" id="login-password" value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>

                <div className='form-bottom-link w-100'>

                  <Link to="/changepassword" className='form-links float-right '>recover password</Link>
                </div>
                {/* btn  */}
                <div>
                  <button className='btn text-white w-100 btn-one login-button '>Log In<Spinner
                    as="span"
                    animation="border"
                    hidden={!loading}
                    size="sm"
                    role="status"
                    
                    aria-hidden="false"
                    className='ms-2'
                  /></button>

                </div>


              </form>
            </div>

          </div>

        </div>
      </div>
    </section>
  </>
  )
}

export default Login